import React from 'react';
import { User } from '../../types/user';
import Card from '../Card';
import Button from '../Button';

interface WeekSelectionProps {
  users: User[];
  selectedUserId: string | null;
  selectedWeek: { start: string; end: string };
  formatDate: (date: Date) => string;
  onUserChange: (userId: string) => void;
  onWeekChange: (direction: 'prev' | 'next') => void;
  onToggleQuickEntry: () => void;
  showQuickEntry: boolean;
}

const WeekSelection: React.FC<WeekSelectionProps> = ({
  users,
  selectedUserId,
  selectedWeek,
  formatDate,
  onUserChange,
  onWeekChange,
  onToggleQuickEntry,
  showQuickEntry,
}) => {
  return (
    <Card variant="default" className="mb-6">
      <Card.Body>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr_auto] gap-4 items-end">
          <div className="mb-0">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">User</label>
            <select
              className="w-full p-2.5 text-sm text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md transition-all focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20"
              value={selectedUserId || ''}
              onChange={(e) => onUserChange(e.target.value)}
            >
              {users.map(user => (
                <option key={user.id} value={user.id}>
                  {user.full_name || user.username}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-0">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Week</label>
            <div className="flex gap-2 items-center">
              <Button onClick={() => onWeekChange('prev')} variant="outline" size="sm">←</Button>
              <div className="flex-1 text-center font-semibold text-sm sm:text-base text-gray-900 dark:text-gray-100">
                {selectedWeek.start && selectedWeek.end && 
                  `${formatDate(new Date(selectedWeek.start))} - ${formatDate(new Date(selectedWeek.end))}`}
              </div>
              <Button onClick={() => onWeekChange('next')} variant="outline" size="sm">→</Button>
            </div>
          </div>

          <Button
            onClick={onToggleQuickEntry}
            variant="primary"
            className="w-full md:w-auto"
          >
            {showQuickEntry ? 'Cancel' : '+ Log Time'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default WeekSelection;
